
define('ldsh!modules/form_editor/templates/editor_custom_google_recaptcha', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="ed-form-group js-label-group">\n  <div>\n    <small data-i18n="formEditor.captcha.google.introduction" class="block mb20"></small>\n    <div class="ed-google-recaptcha-preview"></div>\n  </div>\n\n  <div class="ed-form-group mt20">\n    <small data-i18n="formEditor.captcha.google.user_site_key_intro" class="block mb20"></small>\n    <label for="recaptcha-site-key" data-i18n="formEditor.captcha.google.user_site_key"></label>\n    <input type="text"\n         id="recaptcha-site-key"\n         name="recaptcha-site-key"\n         class="form-control ed-form-item-full js-recaptcha-site-key"\n         placeholder="Site Key"\n         value="' +
((__t = ( siteKey )) == null ? '' : __t) +
'" />\n  </div>\n\n  <div class="ed-form-group mt30">\n    <label for="recaptcha-id-name" data-i18n="editor.idclass.id">Id</label>\n    <input type="text"\n           id="recaptcha-id-name"\n           name="recaptcha-id-name"\n           class="form-control ed-form-item-full js-element-id"\n           value="' +
((__t = ( idName )) == null ? '' : __t) +
'"\n           readonly />\n  </div>\n</div>\n';

}
return __p
};});

